// extracted by mini-css-extract-plugin
export var inputField = "form-module--inputField--bdXiN";
export var checkbox = "form-module--checkbox--enZHC";
export var button = "form-module--button--hXZ76";
export var buttonColumn = "form-module--buttonColumn--uVfI3";